export const BAGY_BRAND = {
  primaryColor: '#C93672'
}

export const BAGY_HOSTNAMES = [
  'bagy',
  'bagy.localhost',
  'erp.bagy.com.br',
  'erp.bagypro.com.br'
]
